import { TFunction } from 'i18next';
import { ResourceListItem } from '../types';
import { FileAssetType, Tag, User } from 'src/graphql/generated/graphql';
import { TagsField } from 'src/components/common/table/columns/tags';
import { DataTableMeta, DateColumn } from '@otp/ui';
import { getFullName } from 'src/utils/user-data';
import { TypeColumn } from './columns/type';
import { ActionsColumn } from './columns/actions';
import { IsActiveColumn } from 'src/components/common/table/columns/is-active';
import React from 'react';

export const getTableConfig = (
  data: ResourceListItem[],
  { t, excludeColumns }: { t: TFunction; excludeColumns?: string[] },
) => [
  ...(excludeColumns?.includes('status')
    ? []
    : [
        {
          name: 'isDisabled',
          label: t('common.status-label'),
          options: {
            customBodyRender: (isDisabled: boolean) => {
              return (
                <IsActiveColumn isDisabled={isDisabled} isDeleted={false} />
              );
            },
          },
        },
      ]),
  ...(excludeColumns?.includes('type')
    ? []
    : [
        {
          name: 'type',
          label: t('common.type'),
          options: {
            customBodyRender: (type: FileAssetType) => {
              return <TypeColumn type={type} />;
            },
          },
        },
      ]),
  ...(excludeColumns?.includes('name')
    ? []
    : [
        {
          name: 'name',
          label: t('common.name'),
          options: {
            sort: true,
          },
        },
      ]),
  ...(excludeColumns?.includes('tags')
    ? []
    : [
        {
          name: 'tags',
          label: t('common.tags'),
          options: {
            customBodyRender: (tags: Tag[]) => {
              return <TagsField tags={tags} />;
            },
          },
        },
      ]),
  ...(excludeColumns?.includes('updatedAt')
    ? []
    : [
        {
          name: 'updatedAt',
          label: t('resources.list.columns.last-updated'),
          options: {
            sort: true,
            customBodyRender: (_: any, column: DataTableMeta) => {
              const resource = data[column.rowIndex];
              const updatedAt = resource.updatedAt || resource.createdAt;

              return <DateColumn date={updatedAt} />;
            },
          },
        },
      ]),
  ...(excludeColumns?.includes('createdBy')
    ? []
    : [
        {
          name: 'createdBy',
          label: t('resources.list.columns.added-by'),
          options: {
            customBodyRender: (createdBy: User) => {
              return getFullName(createdBy, ' ');
            },
          },
        },
      ]),
  ...(excludeColumns?.includes('actions')
    ? []
    : [
        {
          name: 'actions',
          label: t('resources.list.columns.actions.label'),
          options: {
            customBodyRender: (_: any, column: DataTableMeta) => {
              const resource = data[column.rowIndex];

              return <ActionsColumn resource={resource} />;
            },
          },
        },
      ]),
];
